exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".el-popup-parent--hidden .fixed-header{padding-right:0.07813rem}\n", ""]);

// exports
